import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { useSite } from "../context/SiteContext";
import { EnquiryForm, SiteVisitForm, BrochureForm } from "./forms/LeadForms";

const META = {
  enquiry: { title: "Enquire Now", desc: "Share your details and our team will get in touch." },
  "site-visit": { title: "Schedule a Site Visit", desc: "Choose a preferred date and we will confirm your visit." },
  brochure: { title: "Download Brochure", desc: "Please share your details to receive the Krishna Vatika brochure." },
};

export function GlobalModals() {
  const { modal, closeModal } = useSite();
  const m = META[modal];
  return (
    <Dialog open={!!modal} onOpenChange={(o) => !o && closeModal()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto bg-ivory border-gold/30 sm:max-w-2xl rounded-sm" data-testid={`${modal}-modal`}>
        {m && (
          <DialogHeader className="text-left">
            <p className="eyebrow">M & S Green Estate Pvt. Ltd.</p>
            <DialogTitle className="h3">{m.title}</DialogTitle>
            <DialogDescription className="text-charcoal/70">{m.desc}</DialogDescription>
          </DialogHeader>
        )}
        <div className="mt-2">
          {modal === "enquiry" && <EnquiryForm />}
          {modal === "site-visit" && <SiteVisitForm onDone={closeModal} />}
          {modal === "brochure" && <BrochureForm onDone={closeModal} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
